<!-- container-xxl -->
<div class="content-wrapper funding-content-wrapper content-aboutus-outer-container">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body content-body-outer-img-container">
		<img src="assets\images\funding\Group 160.png" alt="about-us">
	</div>
	<div class="content-body">
		<!-- app e-commerce details start -->
		<section class="app-ecommerce-details">
			<div class="row row-container">
				<marquee class="col-12" style="line-height: 3rem;" behavior="scroll" direction="left" scrollamount="6"
					scrolldelay="120" onmouseover="this.stop();" onmouseout="this.start();">
					<p class="p-container">&nbsp;&nbsp;&nbsp; Call for Proposals under RE-RTD is now CLOSED; Deadline
						for
						Proposal Submission was 15th August 2022</p>
				</marquee>
			</div>
			<div class="col-xl-10 application-selection-main-news-bar-outer-contaner">
				<div class="card">
					<div class="card-body">
						<!-- Nav tabs -->
						<ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills nav-justified">
							<li [ngbNavItem]="1">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Call for Proposals</span>
									<span class="d-none d-sm-block">Call for Proposals</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent"></ng-template>
									<!-- <p>Registered Project investigators (PIs) </p>
									<p>Proposals received </p>
									<p>Thematic distribution – solar wind etc (could be taken from backend data) </p> -->
									<div class="row d-flex justify-content-around Registered-container flex-wrap">
										<div class="row d-flex justify-content-around text-center m-1">
											<span class="col-3">
												<img src="assets\images\main-home-slider\Group 208.png" alt=""
													width="100%">
											</span>
											<span
												class="col-6 text-left first-span p-2">{{dashboardCount[0]?.value}}</span>
											<span class="col-12 second-span">Registered Project investigators
												(PIs)</span>
										</div>
										<div class="row d-flex justify-content-around text-center m-1">
											<span class="col-3">
												<img src="assets\images\funding\Group 238.png" alt="" width="100%">
											</span>
											<span class="col-6 text-left first-span p-2">1494</span>
											<span class="col-12 second-span">Proposals received </span>
										</div>
										<!-- <div class="row d-flex justify-content-around text-center m-1">
											<span class="col-3">
												<img src="assets\images\main-home-slider\Group 129.png" alt=""
													width="100%">
											</span>
											<span class="col-6 text-left first-span p-2">9</span>
											<span class="col-12 second-span">Solar and Wind Proposals</span>
										</div> -->
										<!-- <div class="clo-3 m-1">
												<span>icon</span><span>21</span><br>
												<span>Registered Project investigators (PIs)</span>
										</div>
										<div class="clo-3 m-1">Registered Project investigators (PIs)</div>
										<div class="clo-3 m-1">Registered Project investigators (PIs)</div> -->
									</div>
									<p class="link"><a
											href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf">
											Call for Proposal</a></p>

								</ng-template>
							</li>
							<li [ngbNavItem]="2">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Who Can Apply</span>
									<span class="d-none d-sm-block">Who Can Apply</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent1"></ng-template>
									<p>R&D/Academic institutions including Universities, Engineering Colleges (both
										Public
										and Private, duly
										accredited by Government bodies)</p>
									<p>Public Sector Units (PSUs)/Private Industries </p>
									<p>Labs</p>
									<p>Government – example State Renewable Energy Nodal Agencies </p>
									<p>Start-ups duly recognised by the Department for Promotion and Internal Trade
										(DPIIT)
									</p>
									<p>Not for Profit Organisations including think tanks/NGOs</p>
									<p>Societies registered under the Societies Registration Act 1860</p>
									<p>Trusts registered under the Societies Registration Act 1860 </p>
									<!-- <p>Trusts registered under the Societies Registration Act 1860</p> -->
									<p>Organisations engaged in Research and Development for promotion of new and
										renewable
										energy </p>
								</ng-template>
							</li>
							<li [ngbNavItem]="3">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Indicative Thrust Areas</span>
									<span class="d-none d-sm-block">Indicative Thrust Areas</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent1"></ng-template>

									<!-- "{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" -->
									<!--{{documentURL}}/Applyforfunding_typeofactivities_abhinavsoch.pdf-->
									<p class="link"><a
											href="{{documentURL}}/Indicative_Thrust_Areas_for_RD&D_Support.pdf"
											target="_blank" title="Click here Download">
											MNRE RE-RTD Indicative Thrust areas for Funding</a></p>
								</ng-template>
							</li>
							<li [ngbNavItem]="4">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Types of Activities Supported</span>
									<span class="d-none d-sm-block">Types of Activities Supported</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent1"></ng-template>
									<p>Research, design, innovation, technology development and demonstration projects
									</p>
									<p>RE resource assessment </p>
									<p>Technology mapping, validation, improvement, upgrades (low to high TRL levels)
									</p>
									<p>Centre of Excellence </p>
									<p>Strengthening of Existing Testing labs/Creation of new Labs </p>
									<!-- "{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" -->
									<p class="link"><a
											href="{{documentURL}}/Applyforfunding_typeofactivities_abhinavsoch.pdf"
											target="_blank" title="Click here Download">
											Award for Innovation/Start Ups to transform innovative ideas/prototypes to
											commercial products in
											line with MNRE 2017 guidelines on ‘Abhinav Soch – Nayee Sambhawnayen’ </a>
									</p>
									<p>Policy Research and analysis of RE programmes</p>
									<p>Capacity building </p>
								</ng-template>
							</li>
							<li [ngbNavItem]="5">
								<a ngbNavLink>
									<span class="d-block d-sm-none">FAQs</span>
									<span class="d-none d-sm-block">FAQs</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent"></ng-template>
									<ol type="1">
										<li>Would topics not currently mentioned underneath thrust areas also be
											considered
											for funding?<br>
											Thematic areas not explicitly mentioned under the R&D thrust areas could
											also be
											considered for
											financial support based on their novelty, applications, and practical
											significance in furthering
											country’s renewable energy ambitions.
										</li>
										<li>Is co-financing allowed <br>
											Yes, please specify the share of the total project cost in the Proposal
											Format
										</li>
										<li>What are the preferred TRL level in projects? <br>
											The Ministry is looking at projects targeting TRL 4-8 (refer TRL chart) in
											Resources for Grantees
										</li>
										<li>Is technology commercialisation allowed? <br>
											Yes, a standout feature of this scheme is that it supports technology
											commercialisation and transfer
											to Indian industries.
										</li>
										<li>Is technology transfer to international firms supported under the scheme?
											<br>
											The scheme will financially support technology transfer to Indian industry.
											Project implementers are
											free to transfer technology to international firms, but this will not be
											financially supported under
											the grant.
										</li>
										<li>Would international collaboration be allowed? <br>
											Yes, we encourage collaboration with relevant international stakeholders
											(academia/universities/industry, etc.). Collaboration with institutions in
											member countries of ISA,
											will be supported in mutually identified areas.
										</li>
										<li>What are the expected outcomes/impact indicators?
											<p>New products/ prototypes developed</p>
											<p>Number and status of Patents Filed </p>
											<p>Technology transfer to industry </p>
											<p>Journal Publications</p>
											<p>Number of knowledge products created – reports/studies such as resource
												assessment/policy briefs,
												etc. </p>
											<p>Number of collaborations/partnerships formed (involving both domestic and
												international actors
												where applicable)</p>
											<p>Training/capacity building (includes project staff and external
												stakeholders)
											</p>
											<p>Growth in manufacturing reported through data on enhanced manufacturing
												volumes, entry of new
												firms. </p>
											<p>Quantitative and Qualitative data in the form of case studies capturing
												project impact </p>
										</li>
										<li>Where can I find more information on Intellectual Property Rights (IPR)?
											<p>Appendix 2 – General T&C of the Call for Proposal covers MNRE’s role and
												guidelines related to Technology transfer and IPR. More details on Apply
												for
												Funding page </p>
										</li>
										<li>Are start-ups supported?
											<p>Yes, start-ups recognised by DPIIT are eligible</p>
										</li>
									</ol>

								</ng-template>
							</li>
							<li [ngbNavItem]="6">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Funding Support</span>
									<span class="d-none d-sm-block">Funding Support</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent"></ng-template>
									<p>Upto 100% of total project cost to academic institutions/ universities/ research
										institutions/ govt./
										not for profit organisations </p>
									<p>Upto 50% of the project cost to collaborative projects with industry </p>
									<p>Upto 50% cost of project to start-ups (recognised by DPIIT) for technology
										development</p>
									<p>Upto 70% of project cost to Industry/ Research Organisations/ Start Ups -
										upgrading
										from Low TRL to
										High TRLs</p>
								</ng-template>
							</li>
							<li [ngbNavItem]="7">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Project Appraisal and Insurance of Grants</span>
									<span class="d-none d-sm-block">Project Appraisal and Insurance of Grants</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent"></ng-template>
									<div class="row pb-5 row-arrow-container justify-content-center">
										<div class="col-6 d-flex">
											<img src="assets\images\funding\arrow-img 1.png" alt="arrow-img">
											<!-- <div class="col-2 p-1 col-3-one col-2-container">
											<p>STEP - 1</p>
										</div>
										<div class="col-2 p-1 col-3-two col-2-container">
											<p>STEP - 2</p>
										</div>
										<div class="col-2 p-1 col-3-three col-2-container">
											<p>STEP - 3</p>
										</div>
										<div class="col-2 p-1 col-3-four col-2-container">
											<p>STEP - 4</p>
										</div>
										<div class="col-2 col-3-arrow-container">
									  </div> -->
										</div>
									</div>
									<div class="row row-outer-container justify-content-center">
										<div class="col-12 text-center mb-3">
											<h5>Tips for Submitting a Successful Proposal</h5>
						
										</div>
										<div class="col-8 mb-3">
											<p>Develop Proposal which is need based or demand driven </p>
											<p>Avoid duplication </p>
											<p>Adopt a consortium approach - collaboration with industry, international institutes is encouraged
											</p>
											<p>Contribute towards advancing MNRE’s RE policies/ schemes strategic priorities like Make in India,
												National Solar Mission, National Hydrogen Mission, RE Policies/ Schemes, climate commitments,
												circular economy.</p>
											<p>Focus on success indicators such as replicability, scalability, commercialisation, enhanced
												indigenous product development and manufacturing, policy influences, cross sectoral
												applications,
												skill building, socio-economic and environmental benefits. </p>
										</div>
						
									</div>
								</ng-template>
							</li>
							<li [ngbNavItem]="8">
								<a ngbNavLink>
									<span class="d-block d-sm-none">Resources for Grantees</span>
									<span class="d-none d-sm-block">Resources for Grantees</span>
								</a>
								<ng-template ngbNavContent>
									<ng-template [ngTemplateOutlet]="TabContent"></ng-template>
									<!-- <p>Registered Project investigators (PIs) </p>
									<p>Proposals received </p>
									<p>Thematic distribution – solar wind etc (could be taken from backend data) </p> -->
									<div class="row justify-content-around">
										<div class="col-12 justify-content-around d-flex flex-wrap">
											<div class="col-3 text-sm-left border pt-1 mt-3 mb-3">
												<div class="card-body">
													<h3>Application</h3>
												</div>
												<div class="card-header">
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Application/Call_for_Proposal_for_uploading_on_website.pdf"
															class="link">Call for Proposal</a>
													</p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Application/Indicative_Thrust_Areas_for_RD&D_Support.pdf"
															class="link">Indicative Thrust Areas for RD&D Support</a>
													</p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Application/Proforma_for_Submission_of_Proposals_for_RDD&D_Projects.pdf"
															class="link">Performa for Application Submission
														</a></p>
												</div>
											</div>
											<div class="col-3 text-sm-left border pt-1 mt-3 mb-3">
												<div class="card-body">
													<h3>Performas for Project Implementation</h3>
												</div>
												<div class="card-header">
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Final_Statement_Of_Expenditure_(S.O.E.).pdf"
															class="link">Final Statement of Expenditure (S.O.E.)</a></p>
													<p><a target="-blank"
													        href="{{documentURL}}/Resources_for_grantees/Performas/Guidelines_Instructions_for_Technology_Transfer_and_Intellectual_Property_Rights.pdf"
															class="link">Guidelines and Instructions for Technology
															Transfer and Intellectual Property Rights</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Performa_for_Brief_of_Project.pdf"
															class="link">Performa for Brief of Project</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Proforma_for_filling_of_patents_in_Renewable_Energy_Technology.pdf"
															class="link"> Performa for Filling of Patents in Renewable
															Energy Technology </a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Proforma_for_Project_Completion_Report_(PCR).pdf"
															class="link"> Performa for Project Completion Report (PCR)
														</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Proforma_for_Request_for_R&D_Technology_Development_Project_Extension.pdf"
															class="link"> Performa for Request for R&D Technology
															Development Project Extension
														</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Proforma_for_Information_Required_for_Commercializing_Indigenously_developed.pdf"
															class="link"> Performa for Information Required for Commercializing Indigenously developed Renewable Energy Technologies
														</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Proforma_for_Statement_of_Expenditure_(S.O.E.).pdf"
															class="link"> Performa for Statement of Expenditure (SOE)
														</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Proforma_for_Utilization_Certificate_(U.C.).pdf"
															class="link"> Performa for Utilization Certificate (U.C.)
														</a></p>
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Performas/Performa_of_subsequent_release.pdf"
															class="link"> Performa of Subsequent Release
														</a></p>


												</div>
											</div>
											<div class="col-3 text-sm-left border pt-1 mt-3 mb-3">
												<div class="card-body">
													<h3>Policies</h3>
												</div>
												<div class="card-header">
													<p><a target="-blank"
															href="{{documentURL}}/Resources_for_grantees/Policies/MNRE_R&D_Policy_2021.pdf"
															class="link"> MNRE R&D Policy 2021 </a></p>
													>

												</div>
											</div>

										</div>
									</div>


								</ng-template>
							</li>
						</ul>
						<div [ngbNavOutlet]="justifiednav" class="text-muted"></div>
					</div><!-- end card-body -->
				</div><!-- end card -->
			</div>
		</section>
	</div>
</div>
<!-- container-xxl -->